import {ServiceClass} from '@/decorators';
import {areaFieldsList, equipmentFieldsList, junctionBoxFieldsList} from '@/globals';
import i18n from '@/plugins/i18n';
import {AlertService, DataFieldModel, FieldOptions, LoaderService} from '@/sdk';
import {DataFieldApi} from '@/sdk/api-services/data-field.api';
import {nameof} from 'ts-simple-nameof';
import {DropResult} from 'vue-smooth-dnd';
import {SiteLocationService} from './site-location.service';

@ServiceClass()
export class AdminDataFieldService {
    public dataFieldApi: DataFieldApi = new DataFieldApi();

    public areaFieldOptions: Record<string, FieldOptions[]> = {};

    public equipmentFieldOptions: Record<string, FieldOptions[]> = {};

    public junctionBoxFieldOptions: Record<string, FieldOptions[]> = {};

    public areaFields: Array<DataFieldModel> = [];
    public equipmentFields: Array<DataFieldModel> = [];
    public junctionBoxFields: Array<DataFieldModel> = [];

    public selected: number | null = null;
    public selected1: number | null = null;

    public selectedField: DataFieldModel | null = null;

    public selectedFieldOptions: Record<string, FieldOptions[]> = {};

    public dependentFieldOption: string | null = null;

    public isDependent: boolean = false;
    public newOption: FieldOptions | null = new FieldOptions();

    public siteLocationsSrv: SiteLocationService = new SiteLocationService();

    constructor() {
        for (const field of Object.values(areaFieldsList)) {
            this.areaFieldOptions[field] = [];
        }
        for (const field of Object.values(junctionBoxFieldsList)) {
            this.junctionBoxFieldOptions[field] = [];
        }
        // this.loadFieldOptions();
    }

    // public getDependentOptions(fieldKey: string, dependentOnValue: string | Array<string>) {
    //     const tmp = this.equipmentFieldOptions[fieldKey] ?? [];

    //     if (typeof dependentOnValue === 'string') {
    //         return tmp.filter(x => x.dependentOnFieldOptionId === dependentOnValue);
    //     } else if (dependentOnValue instanceof Array) {
    //         return tmp.filter(x => dependentOnValue.includes(x.dependentOnFieldOptionId!));
    //     }

    //     return [];
    // }

    public getDependentItemsOf(fieldId: string, dependentFieldId: string) {
        let options: Array<string> = [];
        const isEquipmentField = !!(equipmentFieldsList as any)[fieldId];

        console.log('getDependentItemsOf', fieldId, dependentFieldId);

        let fieldOptions: FieldOptions[] = [];

        if (isEquipmentField) {
            if (dependentFieldId === equipmentFieldsList.equipmentProtectionTechniqueGas) {
                options = this.siteLocationsSrv.selectedLcoation?.equipmentDetail?.protectionTechniqueGas ?? [];
            }
            if (dependentFieldId === equipmentFieldsList.equipmentProtectionTechniqueDust) {
                options = this.siteLocationsSrv.selectedLcoation?.equipmentDetail?.protectionTechniqueDust ?? [];
            }

            fieldOptions = this.equipmentFieldOptions[fieldId] ?? [];
        } else {
            if (dependentFieldId === junctionBoxFieldsList.junctionBoxProtectionTechniqueGas) {
                options = this.siteLocationsSrv.selectedLcoation?.junctionBoxDetail?.protectionTechniqueGas ?? [];
            }
            if (dependentFieldId === junctionBoxFieldsList.junctionBoxProtectionTechniqueDust) {
                options = this.siteLocationsSrv.selectedLcoation?.junctionBoxDetail?.protectionTechniqueDust ?? [];
            }

            fieldOptions = this.junctionBoxFieldOptions[fieldId] ?? [];
        }
        return fieldOptions.filter(x => x.dependentOnFieldId === dependentFieldId && options.includes(x.dependentOnFieldOptionId!));
    }

    public reset() {
        this.newOption = new FieldOptions();
    }

    public fieldType(field: DataFieldModel) {
        if (field.type === 'select') {
            return i18n.t('Common.SingleSelect') as string;
        } else if (field.type === 'multi-select') {
            return i18n.t('Common.MultiSelect') as string;
        }

        return '';
    }

    public loadAreaFields() {
        new LoaderService().showFullScreenLoader();
        this.dataFieldApi
            .areaFields()
            .subscribe(res => {
                this.areaFields = res.Data ?? [];

                this.areaFields.forEach(x => {
                    this.selectedFieldOptions[x.id!] = [];
                });

                this.selectedFieldOptions = {...this.selectedFieldOptions};
            })
            .add(() => {
                new LoaderService().hideFullScreenLoader();
            });
    }

    public loadEquipmentFields() {
        new LoaderService().showFullScreenLoader();
        this.dataFieldApi
            .equipmentFields()
            .subscribe(res => {
                this.equipmentFields = res.Data ?? [];

                this.equipmentFields.forEach(x => {
                    this.selectedFieldOptions[x.id!] = [];
                });

                this.selectedFieldOptions = {...this.selectedFieldOptions};
            })
            .add(() => {
                new LoaderService().hideFullScreenLoader();
            });
    }

    public loadJunctionBoxFields() {
        new LoaderService().showFullScreenLoader();
        this.dataFieldApi
            .junctionBoxFields()
            .subscribe(res => {
                this.junctionBoxFields = res.Data ?? [];

                this.junctionBoxFields.forEach(x => {
                    this.selectedFieldOptions[x.id!] = [];
                });

                this.selectedFieldOptions = {...this.selectedFieldOptions};
            })
            .add(() => {
                new LoaderService().hideFullScreenLoader();
            });
    }

    public getFieldsOptions(id: string) {
        // this.selectedFieldOptions[id] = [];

        new LoaderService().showFullScreenLoader();
        this.dataFieldApi
            .getDataFieldOptions(id, {
                include: [
                    {
                        relation: 'dependentOnField',
                    },
                ],
                order: `${nameof<FieldOptions>(x => x.sortOrder)} ASC`,
            })
            .subscribe(res => {
                this.selectedFieldOptions[id] = res.Data ?? [];
            })
            .add(() => {
                new LoaderService().hideFullScreenLoader();
            });
    }

    sortOnDrop(payload: DropResult) {
        return new Promise<void>((resolve, reject) => {
            if (payload.removedIndex !== payload.addedIndex) {
                const fieldOptions = this.selectedFieldOptions[this.selectedField!.id!] ?? [];
                const removed = fieldOptions.splice(payload.removedIndex, 1);
                fieldOptions.splice(payload.addedIndex, 0, ...removed);

                this.selectedFieldOptions[this.selectedField!.id!] = fieldOptions;

                const changedIndexes = fieldOptions.map((x, i) => {
                    return {
                        id: x.id as string,
                        sortOrder: i,
                    };
                });

                this.dataFieldApi
                    .saveFieldOptionSortOrders(changedIndexes)
                    .then(() => {
                        // this.AlertSrv.show('success', 'Field options sorted successfully.');
                        this.getFieldsOptions(this.selectedField!.id!);
                    })
                    .catch(() => {
                        new AlertService().show('error', 'Failed to sort field options.');
                    })
                    .finally(() => {
                        resolve();
                    });
            } else {
                resolve();
            }
        });
    }

    public getEquipmentFieldOptionValue(fieldId: string, optionId: string) {
        return this.equipmentFieldOptions[fieldId]?.find(x => x.id === optionId)?.value;
    }

    getValueFromOptions = (fieldId: string, value: any) => {
        // const field = this.equipmentFields.find(x => x.id === fieldId) || this.junctionBoxFields.find(x => x.id === fieldId);
        const fieldOptions = this.equipmentFieldOptions[fieldId] || this.junctionBoxFieldOptions[fieldId];

        console.log('getValueFromOptions', fieldId, value, fieldOptions);

        if (value instanceof Array) {
            return value
                .map(x => fieldOptions?.find(o => o.id === x)?.value)
                .filter(x => x != null)
                ?.join(', ');
        }
        return fieldOptions?.find(x => x.id === value)?.value;
    };

    public getJunctionBoxFieldOptionValue(fieldId: string, optionId: string) {
        return this.junctionBoxFieldOptions[fieldId]?.find(x => x.id === optionId)?.value;
    }

    public loadAreaFieldOptions() {
        new LoaderService().showFullScreenLoader(`Loading Area field's options.`);
        return this.dataFieldApi
            .areaFieldOptions()
            .then(res => {
                this.areaFieldOptions = res;

                return res;
            })
            .catch(err => {
                //
            })
            .finally(() => {
                new LoaderService().hideFullScreenLoader();
            });
    }

    public loadEquipmentFieldOptions() {
        new LoaderService().showFullScreenLoader(`Loading Equipment's field options.`);
        return this.dataFieldApi
            .equipmentFieldOptions()
            .then(res => {
                this.equipmentFieldOptions = res as any;

                return res;
            })
            .catch(err => {
                //
            })
            .finally(() => {
                new LoaderService().hideFullScreenLoader();
            });
    }

    public loadJunctionBoxFieldOptions() {
        new LoaderService().showFullScreenLoader(`Loading Junction Box field options.`);
        return this.dataFieldApi
            .junctionBoxFieldOptions()
            .then(res => {
                this.junctionBoxFieldOptions = res as any;

                return res;
            })
            .catch(err => {
                //
            })
            .finally(() => {
                new LoaderService().hideFullScreenLoader();
            });
    }
}
